/**
 * Vehicle year options for quotation forms.
 * Keep start year explicit (same pattern as before); bump when a new model year opens.
 * Counts keep the previous oldest year when the start year advances (auto: 1995, moto: 2005).
 */
export const VEHICLE_YEARS_START = 2026;
export const AUTOMOTOR_YEAR_COUNT = 32;
export const MOTOVEHICULO_YEAR_COUNT = 22;

export function buildVehicleYears(startYear = VEHICLE_YEARS_START, length) {
    return Array.from({length}, (_, i) => {
        const year = (startYear - i).toString();
        return {value: year, label: year};
    });
}
